import { NumberInput } from '@commenda/kakashi';
import { useContext } from 'react';
import { useFormField } from '../../hooks/useFormField';
import { FormContext } from '../../hooks/FormContext';
import { strOrUndef } from '../../utils/context-values';
import { IndirectTaxRegistrationHelper } from '../../../indirect-tax/registrations/utils/IndirectTaxRegistrationHelper';
import { DEFAULT_JURISDICTION_CONTEXT_KEY } from './IndirectTaxRegistration/types';
import { LabelWithGuidanceTooltip } from './LabelWithGuidanceTooltip';

export const NumberInputComponent = ({
  fieldId,
  label,
  description,
  props = {},
  guidance,
  validation,
}: any) => {
  const { dslContext } = useContext(FormContext);
  const {
    format,
    formatWithCommas = true,
    jurisdictionContextKey = DEFAULT_JURISDICTION_CONTEXT_KEY,
    disabled: propsDisabled = false,
  } = props;
  const { value: rawValue, error, disabled, isRequired, setValue } =
    useFormField<number | string>(fieldId, {
      rules: validation?.rules,
      disabledFromProps: propsDisabled,
    });
  // NumberInput's formatting expects undefined, not an empty string, for "no value"
  const value = rawValue === undefined || rawValue === '' ? undefined : rawValue;

  const currencyCode =
    format === 'currency'
      ? IndirectTaxRegistrationHelper.getRegistrationCurrencyCode({
          jurisdictionId:
            strOrUndef(dslContext?.[jurisdictionContextKey]) ?? '',
        })
      : undefined;

  return (
    <div className="mb-4" data-field-id={fieldId}>
      {(label || description) && (
        <LabelWithGuidanceTooltip
          label={label}
          description={description}
          guidance={guidance?.text}
          isRequired={isRequired}
        />
      )}
      <NumberInput
        value={value}
        onChange={(next) => setValue(next ?? undefined)}
        error={error}
        formatWithCommas={formatWithCommas}
        disabled={disabled}
        className={currencyCode ? 'pl-7xl' : undefined}
        leftEl={
          currencyCode
            ? () => (
                <span className="txt-medium-regular text-text-tertiary whitespace-nowrap pl-3xl">
                  {currencyCode}
                </span>
              )
            : undefined
        }
        rightEl={
          format === 'percentage'
            ? () => <span className="text-text-quaternary">%</span>
            : undefined
        }
      />
    </div>
  );
};
